<div class="wccard" style="border-radius: 4px; overflow: hidden; ">
  <div class="sim-modal-header" style="position: sticky; top: 0; z-index: 2;">
    <div class="d-flex align-items-center">
      <!-- content header -->
      <div class="d-flex flex-column">

        <!-- <p class="mb-1 f-16 font-weight-600 d-flex">
        Based on <span class="font-weight-600 mr-3">Job Description</span> <span><i class="fa-regular fa-paperclip"></i>
        </span> <span class="text-webbtree-green f-12 f-12 font-weight-normal">Filename</span> </p> -->
        <p class="mb-1 f-16 font-weight-600">
          Advanced Filters </p>
        <p class="f-12 mb-0">You can modify your search based on filters below</p>
      </div>
      <!-- modal cta's -->
      <div class="d-flex ms-auto flex-column justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div>
            <span *ngIf="!recCandLoader" class="text-right">
              <span class="font-weight-500 f-18">{{totalCandidatesCount | indianNumberFormat}}</span> Candidates Found
            </span>
            <span *ngIf="recCandLoader" class="spinner-border text-webbtree-green mb-3">
              <span class="sr-only">Loading...</span>
            </span>
          </div>
           <!-- <div class="missing-field-msg" *ngIf="!checkIfFilterisSelected() && locationSelectedList?.length == 0">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>No filters selected</span>
          </div>
          <div class="missing-field-msg" *ngIf="checkIfFilterisSelected() && locationSelectedList?.length == 0">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>Location required</span>
          </div> -->
          <div class="ml-3">
            <button data-testid="auto-advance-search-button-1" class="btn-trms-white mr-2" (click)="closeAdvanceSearch()">Cancel</button>
            <button data-testid="auto-advance-search-button-2" class="btn-trms-small" (click)="sendDataToParent()"
             >Search</button>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- <div class="">
    <div class="col pl-0"> -->
  <div class="wccard p-3 advsearchbox f-12" style="height: 435px; overflow-y: scroll;">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex justify-content-between">
          <p class="f-14 font-weight-600 mb-1 d-flex align-items-baseline">Boolean or Keyword Search <span
              *ngIf="isEditing" class="f-10 font-weight-normal ml-2 text-9696">(Click Enter to Save your Search)</span>
          </p>
          <div class="d-flex" style="justify-content: flex-end;">
            <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex mr-1"
              (click)="clearBoolean()" *ngIf="keywordInput?.value">
              Clear
            </span>
          </div>
        </div>

        <div class="position-relative">
          <div class="textarea-box">
            <textarea data-testid="auto-advance-search-textarea-1" class="wc-form-control no-shadow w-100 inputheight searchScrollFix" [formControl]="keywordInput"
              placeholder="Example: ('Data Analyst' OR 'Business Analyst') AND (SQL AND Python)" [disabled]="!isEditing"
              style="min-height: 66px; max-height: 300px;" (blur)="selectedItem($event, 'booleansearch')"
              [ngClass]="{'borderblue': isEditing, 'save-input': !isEditing}"
              (keydown.enter)="selectedItem($event, 'booleansearch')" (click)="isEditing = true">
              </textarea>


          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col d-flex justify-content-between align-items-center">
        <p class="search-heading mb-4 mt-2">
          Employment Details
        </p>
        <div class="d-flex" style="justify-content: flex-end;">
          <span class="f-13 icon-color font-weight-500 text-webbtree-green pointer d-flex mr-1"
            (click)="clearFilters()">
            Reset All
          </span>
        </div>
      </div>
    </div>

    <!-- Name filter-->
    <div class="row">
      <div class="col-md-6">
        <p class="sub-heading mb-1 font-weight-500">Location
         <i class="fa-regular fa-circle-info f-12" *ngIf="defaultContinent && locationSelectedList?.length == 0"  [ngbTooltip]="tooltipTemplate" placement="right"></i>

 </p>
   <ng-template #tooltipTemplate>
  Showing results for <b>{{ defaultContinent | titlecase }}</b>, add locations to search globally.
</ng-template>
        <div class="position-relative">
          <input data-testid="auto-advance-search-input-1" type="text" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="Enter Location...."
            [formControl]="locationInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodesForLocation"
            (keyup)="onTypeAheadSearch($event, 'location')" [matAutocomplete]="location_auto"
            [matChipInputFor]="location_chipList" [matChipInputAddOnBlur]="addOnBlur"
            (blur)="removeTypeahead('location')">
          <div *ngIf="showLocationLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>

          <mat-autocomplete #location_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'location')">
            <mat-option *ngFor="let cl of locationList"
              [value]="{key: cl.value, doc_count: cl.doc_count, continent: cl?.location_continent, location_type: cl?.location_type}"
              [matTooltip]="getTooltipText(cl)" [matTooltipClass]="{ 'eu-tooltip text-black': true }"
              matTooltipPosition="above" [disabled]="isLocationDisabled(cl)">
              <span class="text-truncate">{{cl.value | titlecase}}</span>
              <span class="float-right f-12 text-9696 mt-2">{{cl?.location_type}}</span>
            </mat-option>
          </mat-autocomplete>
          <mat-chip-grid #location_chipList>
            <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip" [removable]="removable"
              (removed)="removeChip(cl, 'location')" *ngFor="let cl of locationSelectedList">

              <span
                class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
                <span class="mx-1">{{cl.chipkey | titlecase}}</span>
              </span>
              <!-- <i class="far fa-times f-12 green-chip" matChipRemove style="margin-left: 1px;
                    margin-top: 5px;"></i> -->
              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
        </div>
      </div>
      <div class="col-md-6 small-select">
        <p class="sub-heading font-weight-500" style="margin-bottom: 5px;">Distance <i
            class="fa-regular fa-circle-info f-12"
            matTooltip="Distance filter is effective only for city-level locations"
            [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
        <div class="d-flex" style="margin-top: 4px;">
          <input data-testid="auto-advance-search-input-2" class="wc-form-control no-shadow inputheight mb-2 mr-2 w-75"
            [ngClass]="{'disabled-input': locationSelectedList?.length == 0 || locationType !== 'city'}"
            onwheel="this.blur()" type="number"
            [disabled]="locationType !== 'city' || locationSelectedList?.length == 0"
            placeholder="Enter distance in miles or kms" [formControl]="distanceform"
            (keyup)="typeAheadSearch($event, 'distance')" min="0" max="500">
          <select data-testid="auto-advance-search-select-1" name="distancetype" (change)="typeAheadSearch($event, 'distancetype')"
            [ngClass]="{'disabled-input': locationSelectedList?.length == 0 || locationType !== 'city'}"
            [disabled]="locationType !== 'city' || locationSelectedList?.length == 0" [formControl]="distancetype"
            class="new-form no-shadow wc-select f-12 w-25 distance" style="width: 25%!important;">
            <option value="miles" selected>Miles</option>

            <option value="kilometers">Kms</option>
          </select>

          <br>

        </div>
        <p *ngIf="distanceform?.errors?.pattern" class="text-danger f-12 pt-1">
          Only whole numbers are allowed</p>
        <p *ngIf="distanceform.errors?.min && (distanceform.dirty || distanceform.touched)"
          class="f-12 text-danger m-0"> Value should be greater than 0</p>
        <p *ngIf="distanceform.errors?.max && (distanceform.dirty || distanceform.touched)"
          class="f-12 text-danger m-0"> Value should be less than 500</p>
        <p *ngIf="!distanceform?.value && (distanceform.dirty || distanceform.touched)" class="f-12 text-danger m-0">
          This field is required</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 small-select">
        <div class="d-flex">
          <p class="sub-heading font-weight-500 mb-1">Job Title</p>
          <div class="d-flex align-items-center mb-1">

            <select data-testid="auto-advance-search-select-2" name="jobtitletype" (change)="filterByStatus($event, 'jobtitle')"
              class="new-form no-shadow wc-select f-12" [(ngModel)]="jobtitletype">
              <option value="Current" selected>Current</option>
              <option value="Current or Past">Current or Past</option>
              <option value="All" style="display: none;">Current or Past</option>
            </select>


          </div>
        </div>
        <div class="position-relative">
          <input data-testid="auto-advance-search-input-3" class="wc-form-control no-shadow w-100 inputheight mb-2" [formControl]="jobTitleInput"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (keyup)="onTypeAheadSearch($event, 'jobtitle')"
            (keyup.enter)="selectedItem($event, 'jobtitle')" placeholder="Enter Job Title or Boolean...."
            [matAutocomplete]="jobtitle_auto" [matChipInputFor]="jobtitle_chipList"
            (blur)="removeTypeahead('jobtitle')">
          <div *ngIf="showJobTitleLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <mat-autocomplete #jobtitle_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'jobtitle')">
          <mat-option *ngFor="let jt of jobTitleList" [value]="{key: jt.value, doc_count: jt.doc_count}">
            <span class="d-flex align-items-center">
              <span class="text-truncate">{{jt.value | titlecase}}</span>
            </span>
          </mat-option>
        </mat-autocomplete>
        <mat-chip-grid #jobtitle_chipList>
          <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip" [removable]="removable"
            [ngClass]="{ 'bg-ai-chip': jobtitle.isSuggestion }" *ngFor="let jobtitle of jobTitleSelectedList"
            (removed)="removeChip(jobtitle, 'jobtitle')">

            <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center"
              [ngClass]="{ 'text-webbtree-green': !jobtitle.isSuggestion }">
              <span class="mx-1">{{jobtitle.chipkey | titlecase}}</span>
            </span>
            <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>

          </mat-chip-row>
        </mat-chip-grid>
        <div style="overflow: hidden;" [ngClass]="isOpenAITitleLoading || showOpenAITitleSuggestions ? 'pt-3' : ''">
          <div class="pr-2 flex-shrink-0 d-flex align-items-center mb-2"
            *ngIf="showOpenAITitleSuggestions && !isOpenAITitleLoading">
            <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500 ml-1">
              <i class="fa fa-stars"></i>
              AI Search Suggestions
            </span>
            <i class="fal fa-info-circle ml-1 pointer"
              matTooltip="Get AI recommended job titles and skills to expand your search and get enhanced results."
              [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above"></i>
          </div>
          <div *ngIf="isOpenAITitleLoading" class="shimmer-loader"
            style="height: 23px; width: 300px; border-radius: 10px;"></div>
          <div class="overflow-hidden pl-2 w-100">
            <openai-suggested-titles [removeSelected]="true" [onlyExisiting]="true" showOnly="titles"
              [showIcons]="false" [continent]="selectedContinent" [showCount]="false"
              (change)="setTitleSuggestions($event)" (loading)="openaiTitleLoading($event)" [query]="openAIAll"
              [maxChips]="5" [updateChips]="updatedAiTitleChips" [clear]="clearAiTitleChips"
              [exclude]="openAIExcludeJobTitles" [keepSuggestions]="true" [titleAggregateType]="jobTitleAggregateType"
              [titleType]="jobTitleType" [jobtitleAndSkillAIData]="jobtitleAndSkillAIData">
            </openai-suggested-titles>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <p class="sub-heading font-weight-500" style="margin-bottom: 8px;">Past Job Title</p>
        <div class="position-relative">
          <input data-testid="auto-advance-search-input-4" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="Enter Past Job Title...."
            [formControl]="pastJobTitleInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (keyup.enter)="selectedItem($event, PAST_JOB_TITLE)" (keyup)="onTypeAheadSearch($event, PAST_JOB_TITLE)"
            [matAutocomplete]="past_job_title_auto" [matChipInputFor]="past_job_title_chipList"
            [matChipInputAddOnBlur]="addOnBlur" (blur)="removeTypeahead('pastjobtitle')">
          <div *ngIf="showPastJobTitleLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>

          <mat-autocomplete #past_job_title_auto="matAutocomplete"
            (optionSelected)="selectedItem($event, PAST_JOB_TITLE)">
            <mat-option *ngFor="let cl of pastJobTitleList" [value]="{key: cl.value, doc_count: cl.doc_count}">
              {{cl.value | titlecase}}
              <!-- <span class="f-12 text-9696">({{cl.doc_count}})</span> -->
            </mat-option>
          </mat-autocomplete>
          <mat-chip-grid #past_job_title_chipList>
            <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
              [ngClass]="{ 'bg-ai-chip': cl.isSuggestion }" [removable]="removable"
              (removed)="removeChip(cl, PAST_JOB_TITLE)" *ngFor="let cl of pastJobTitleSelectedList">

              <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center"
                [ngClass]="{ 'text-webbtree-green': !cl.isSuggestion }">
                <span class="mx-1">{{cl.chipkey | titlecase}}</span>
              </span>
              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div style="overflow: hidden;"
            [ngClass]="isOpenAIPastJobTitleLoading || showOpenAIPastJobTitleSuggestions ? 'pt-3' : ''">
            <div class="pr-2 flex-shrink-0 d-flex align-items-center mb-2"
              *ngIf="showOpenAIPastJobTitleSuggestions && !isOpenAIPastJobTitleLoading">
              <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500 ml-1">
                <i class="fa fa-stars"></i>
                AI Search Suggestions
              </span>
              <i class="fal fa-info-circle ml-1 pointer"
                matTooltip="Get AI recommended job titles and skills to expand your search and get enhanced results."
                [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above"></i>
            </div>

            <div *ngIf="isOpenAIPastJobTitleLoading" class="shimmer-loader"
              style="height: 23px; width: 300px; border-radius: 10px;"></div>
            <div class="overflow-hidden pl-2 w-100">
              <openai-suggested-titles [removeSelected]="true" [onlyExisiting]="true" showOnly="pasttitle"
                [showIcons]="false" [continent]="selectedContinent" [showCount]="false"
                (change)="setPastJobTitleSuggestions($event)" (loading)="openaiPastJobTitleLoading($event)"
                [exclude]="openAIExcludePastJobTitles" [query]="openAIAll" [maxChips]="5"
                [updateChips]="updatedAiPastJobTitleChips" [titleAggregateType]="pastJobTitleAggregateType"
                [titleType]="pastJobTitleType" [clear]="clearAiPastTitleChips" [keepSuggestions]="true"
                [jobtitleAndSkillAIData]="jobtitleAndSkillAIData">
              </openai-suggested-titles>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">

        <p class="sub-heading font-weight-500" style="margin-bottom: 8px;">Skills</p>
        <!-- (click)="typeAheadSearch($event, 'skills')" -->
        <div class="position-relative">
          <input data-testid="auto-advance-search-input-5" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="Enter Skills or Boolean...."
            [formControl]="skillsInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (keyup.enter)="selectedItem($event, 'skills')" (keyup)="onTypeAheadSearch($event, 'skills')"
            [matAutocomplete]="skills_auto" [matChipInputFor]="skills_chipList" [matChipInputAddOnBlur]="addOnBlur"
            (blur)="removeTypeahead('skills')">
          <div *ngIf="showSkillLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <mat-autocomplete #skills_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'skills')">
            <mat-option *ngFor="let s of skillsList" [value]="{key: s.value, doc_count: s.doc_count}">
              <span class="d-flex align-items-center">
                <span class="text-truncate">{{s.value | titlecase}}</span>
                <!-- <span class="f-12 text-9696"> ({{s.doc_count}})</span> -->
              </span>
            </mat-option>
          </mat-autocomplete>
          <mat-chip-grid #skills_chipList>
            <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip" [removable]="removable"
              (removed)="removeChip(s, 'skills')" [ngClass]="{ 'bg-ai-chip': s.isSuggestion }"
              *ngFor="let s of skillsSelectedList">
              <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center"
                [ngClass]="{ 'text-webbtree-green': !s.isSuggestion }">
                <span class="mx-1">{{s.chipkey | titlecase}}</span>
                <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div style="overflow: hidden;" [ngClass]="isOpenAISkillsLoading || showOpenAISkillsSuggestions ? 'pt-3' : ''">
            <div class="pr-2 flex-shrink-0 d-flex align-items-center mb-2"
              *ngIf="showOpenAISkillsSuggestions && !isOpenAISkillsLoading">
              <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500 ml-1">
                <i class="fa fa-stars"></i>
                AI Search Suggestions
              </span>
              <i class="fal fa-info-circle ml-1 pointer"
                matTooltip="Get AI recommended job titles and skills to expand your search and get enhanced results."
                [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above"></i>
            </div>
            <div *ngIf="isOpenAISkillsLoading" class="shimmer-loader"
              style="height: 23px; width: 300px; border-radius: 10px;"></div>
            <div class="overflow-hidden pl-2 w-100">
              <openai-suggested-titles [removeSelected]="true" [onlyExisiting]="true" showOnly="skills"
                [showIcons]="false" [continent]="selectedContinent" [showCount]="false"
                (change)="setSkillsSuggestions($event)" (loading)="openaiSkillsLoading($event)" [query]="openAIAll"
                [maxChips]="5" [exclude]="openAIExcludeSkills" [clear]="clearAiSkillChips"
                [updateChips]="updatedAiSkillChips" [keepSuggestions]="true"
                [jobtitleAndSkillAIData]="jobtitleAndSkillAIData">
              </openai-suggested-titles>
            </div>
          </div>
        </div>


      </div>
      <div class="col-md-6 small-select">
        <div class="d-flex">
          <p class="sub-heading font-weight-500 mb-1">Industry</p>

          <div class="d-flex align-items-center mb-1">
            <select data-testid="auto-advance-search-select-3" name="industrytype" (change)="filterByStatus($event, 'industry')" [(ngModel)]="industrytype"
              class="new-form no-shadow wc-select f-12">
              <option value="Current" selected>Current</option>
              <option value="Current or Past">Current or Past</option>
              <option value="All" style="display: none;">Current or Past</option>
              <option value="Past">Past</option>
            </select>
          </div>

        </div>


        <!-- (click)="typeAheadSearch($event, 'industry')" -->
        <div class="position-relative">
          <input data-testid="auto-advance-search-input-6" class="wc-form-control no-shadow w-100 inputheight mb-2"
            placeholder="eg. Information Technology, Banking, etc" [formControl]="industryInput"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (keyup)="onTypeAheadSearch($event, 'industry')"
            (keyup.enter)="selectedItem($event, 'industry')" [matAutocomplete]="industry_auto"
            [matChipInputFor]="industry_chipList" [matChipInputAddOnBlur]="addOnBlur"
            (blur)="removeTypeahead('industry')">
          <div *ngIf="showIndustryLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <mat-autocomplete #industry_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'industry')">
            <mat-option *ngFor="let industry of industryList"
              [value]="{key: industry.value, doc_count: industry.doc_count}">
              <span class="d-flex align-items-center">
                <span class="text-truncate">{{industry.value | titlecase}}</span>
                <!-- <span class="f-12 text-9696"> ({{industry.doc_count}})</span> -->
              </span>
            </mat-option>
          </mat-autocomplete>
          <mat-chip-grid #industry_chipList>
            <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip f-12" [removable]="removable"
              (removed)="removeChip(industry, 'industry')" *ngFor="let industry of industrySelectedList">


              <span class="trim-chip text-truncate text-webbtree-green">{{industry.chipkey | titlecase}}
                <!-- <span class="f-12 text-webbtree-green">({{industry.doc_count}})</span> -->
              </span>

              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="d-flex flex-column">
            <span class="trim-chip  text-webbtree-green underline-on-hover d-flex" *ngFor="let jt of industryTopList"
              (click)="addToSelectedList(jt,'industry')">
              <span class="text-truncate">{{jt.key | titlecase}}</span>
              <span class="f-12 text-webbtree-green">({{jt.doc_count}})</span>
            </span>
          </div>
        </div>






      </div>
    </div>


    <div class="row">
      <div class="col-md-6 small-select">
        <div class="d-flex">
          <p class="sub-heading mb-1 font-weight-500">Company</p>
          <div class="d-flex align-items-center mb-1">
            <select data-testid="auto-advance-search-select-4" name="companytype" (change)="filterByStatus($event, 'company')" [(ngModel)]="companytype"
              class="position-relative no-outline inputheight mr-4" class="new-form no-shadow wc-select f-12">
              <option value="Current" selected>Current</option>
              <option value="Current or Past">Current or Past</option>
              <option value="All" style="display: none;">Current or Past</option>
              <option value="Past">Past</option>
            </select>
          </div>
        </div>
        <div class="position-relative">
          <input data-testid="auto-advance-search-input-7" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="eg. Amazon, Google, etc"
            [formControl]="companyInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (keyup)="onTypeAheadSearch($event, 'company')" (keyup.enter)="selectedItem($event, 'company')"
            [matAutocomplete]="company_auto" [matChipInputFor]="company_chipList" [matChipInputAddOnBlur]="addOnBlur"
            (blur)="removeTypeahead('company')">
          <div *ngIf="showCompanyLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>

          <mat-autocomplete #company_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'company')">
            <mat-option *ngFor="let comp of companyList" [value]="{key: comp.key, doc_count: comp.doc_count}">
              <span class="d-flex align-items-center">
                <span>
                  <span class="compnaylogoplaceholder mr-2">
                    <img [src]="comp?.companylogo" *ngIf="comp?.companylogo" class="img-fluid" alt="">
                    <i class="fas fa-building f-12" *ngIf="!comp?.companylogo"></i>
                  </span>
                </span>
                <span class="text-truncate">{{comp.key | titlecase}}</span>
              </span>
            </mat-option>
          </mat-autocomplete>

          <mat-chip-grid #company_chipList class="company-mat-chip">
            <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
              [ngClass]="{ 'bg-ai-chip': company.isSuggested, 'bg-chip': !company.isSuggested, 'excluded-chip': company.isExcluded }"
              [removable]="removable" (removed)="removeChip(company, 'company')"
              *ngFor="let company of companySelectedList">
              <span class="compnaylogoplaceholder-chip">
                <img [src]="company?.companylogo" *ngIf="company?.companylogo" class="img-fluid" alt="">
                <i class="fas fa-building f-12" *ngIf="!company?.companylogo"></i>
              </span>
              <span
                class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
                <span class="mx-1">{{company.chipkey | titlecase}}</span>
              </span>

              <!-- <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center font-weight-lighter">
                      <mat-icon *ngIf="company.isExcluded" class="f-12 mr--5 mt-1 text-danger" matTooltip="Excluded" [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-minus-circle pointer" (click)="excludeFilterItem(company.key,'company')"></i></mat-icon>
                      <mat-icon *ngIf="!company.isExcluded" matTooltip="Exclude" [matTooltipClass]="{ 'red-tooltip text-black': true }" class="f-12 mr--5 mt-1"><i class="far fa-minus-circle pointer" (click)="excludeFilterItem(company.key,'company')"></i></mat-icon>
                    </span> -->
              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="d-flex flex-column mt-2">
            <!-- ai suggestions -->
            <div>
              <div class="pr-2 flex-shrink-0 d-flex align-items-center"
                *ngIf="loadSuggestions && companyAiSuggestions && companyAiSuggestions.length">
                <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500 ml-1">
                  <i class="fa fa-stars"></i>
                  Similar Companies
                </span>
              </div>
              <div *ngIf="!loadSuggestions && companySelectedList.length" class="shimmer-loader"
                style="height: 23px; width: 300px; border-radius: 10px;"></div>

              <div class="d-flex overflow-hidden pl-2 w-100 flex-wrap">
                <div class="d-flex align-items-center mb-2 pointer ai_chip" *ngFor="let c of companyAiSuggestions"
                  (click)="addToSelectedList(c,'company')">
                  <mat-icon class="leading_icon">add</mat-icon>
                  <span class="compnaylogoplaceholder-chip mr-1"
                    [ngClass]="{'bg-white': c?.companylogo , 'bg-color-company': !c?.companylogo}">
                    <img [src]="c?.companylogo" *ngIf="c?.companylogo" class="img-fluid" alt="">
                    <i class="fas fa-building f-12" *ngIf="!c?.companylogo"></i>
                  </span>
                  <span class="text-truncate">{{c.chipkey | titlecase}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <p class="sub-heading font-weight-500" style="margin-bottom: 8px;">Company Size</p>
        <div class="mb-2 advsearchpinput">
          <p-multiSelect [options]="companySizeOption" [(ngModel)]="companysize"
            (onChange)="selectedItem($event, 'companysize')" placeholder="Select Company Size" optionLabel="name" [selectedItemsLabel]="'Select Company Size'" [display]="'chip'"
            [filter]="false">

            <ng-template let-value pTemplate="selectedItems">
              <!-- <div>Select Company Size</div> -->
              <!-- <span *ngIf="!value || value.length === 0">
                Select Company Size
              </span> -->
              <span *ngIf="value?.length">
                {{ value.length }} selected
              </span>
            </ng-template>

            <ng-template pTemplate="header">
              <div class="flex align-items-center" style="position: absolute!important; left: 36px!important;">
                <span class="p-ml-2">All</span>
              </div>
            </ng-template>

            <ng-template let-cs pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ cs }}</div>
              </div>
            </ng-template>

          </p-multiSelect>
        </div>
        <mat-chip-grid  #companysize_chipList *ngIf="!companysize.includes('All')">
          <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip" [removable]="removable"
            *ngFor="let cs of companysize">

            <span class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
              <span class="mx-1">{{cs}}</span>
            </span>
            <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" (click)="removeChip(cs, 'companysize')" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>

          </mat-chip-row>
        </mat-chip-grid>
        <!-- <mat-chip-list #companysize_chipList *ngIf="!companysize.includes('All')">
          <mat-chip class="mr-2 my-1 p-1 rightsideclose text-truncate green-chip" [removable]="removable"
            *ngFor="let cs of companysize">

            <span class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
              <span class="mx-1">{{cs}}</span>
            </span>
            <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>
          </mat-chip>
        </mat-chip-list>

        <mat-chip-list #companysize_chipList>
          <mat-chip class="mr-2 p-1 my-1 rightsideclose text-truncate green-chip" [removable]="removable"
            *ngIf="companysize.includes('All')">

            <span class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
              <span class="mx-1">All</span>
            </span>
            <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>
          </mat-chip>
        </mat-chip-list> -->
         <mat-chip-grid  #companysize_chipList [removable]="removable" *ngIf="companysize.includes('All')">
          <mat-chip-row class="mr-2 my-1 p-1 rightsideclose text-truncate green-chip" [removable]="removable"
            *ngFor="let cs of companysize">

            <span class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
              <span class="mx-1">All</span>
            </span>
            <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip"  (click)="removeChip(cs, 'companysize')"  style="margin-left: 1px; margin-top: 0px;"></i>
              </span>

          </mat-chip-row>
        </mat-chip-grid>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 small-select">
        <div class="d-flex">
          <p class="sub-heading mb-1 font-weight-500">Functions</p>
        </div>
        <div class="position-relative">
          <input data-testid="auto-advance-search-input-8" class="wc-form-control no-shadow w-100 inputheight mb-2" [formControl]="functionsInput"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (keyup)="onTypeAheadSearch($event, 'functions')"
            (keyup.enter)="selectedItem($event, 'functions')" placeholder="Enter Function Name"
            [matAutocomplete]="functions_auto" [matChipInputFor]="functions_chipList"
            (blur)="removeTypeahead('functions')">
          <div *ngIf="showFunctionsLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <mat-autocomplete #functions_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'functions')">
          <mat-option *ngFor="let fL of functionsList" [value]="{key: fL.value, doc_count: fL.doc_count}">
            <span class="d-flex align-items-center">
              <span class="text-truncate">{{fL.value | titlecase}}</span>
            </span>
          </mat-option>
        </mat-autocomplete>
        <mat-chip-grid #functions_chipList>
          <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip" [removable]="removable"
            *ngFor="let fun of functionSelectedList" (removed)="removeChip(fun, 'functions')">

            <span class="trim-chip text-truncate green-chip hoverable-element f-12 d-flex align-items-center">
              <span class="mx-1">{{fun.chipkey | titlecase}}</span>
            </span>
            <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>

          </mat-chip-row>
        </mat-chip-grid>
      </div>

      <div class="col-md-6">
        <p class="sub-heading font-weight-500" style="margin-bottom: 4px;">Seniority</p>
        <div class="mb-2 advsearchpinput">
          <p-multiSelect [options]="seniorityList" [(ngModel)]="seniority"
            (onChange)="selectedItem($event, 'seniority')" placeholder="Select Seniority" optionLabel="name"
            [filter]="false">
            <ng-template let-value pTemplate="selectedItems">
              <!-- <div>Select Seniority</div> -->
              <!-- <span *ngIf="!value || value.length === 0">
                Select Company Size
              </span> -->
              <span *ngIf="value?.length">
                {{ value.length }} selected
              </span>
            </ng-template>
            <ng-template pTemplate="header">
              <div class="flex align-items-center" style="position: absolute!important; left: 36px!important;">
                <div class="p-multiselect-header-checkbox">
                  <span class="p-checkbox-label">All</span>
                </div>
              </div>
            </ng-template>
            <ng-template let-cs pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ cs | titlecase}}</div>
              </div>
            </ng-template>
          </p-multiSelect>
        </div>

        <!-- <mat-chip-set #seniority__chipList *ngIf="!seniority.includes('All')">
          <mat-chip class="mr-2 my-1 rightsideclose text-truncate green-chip" [removable]="removable"
            *ngFor="let cs of seniority">

            <span class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
              <span class="mx-1">{{cs | titlecase}}</span>
            </span>
            <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>
          </mat-chip>
        </mat-chip-set>

        <mat-chip-set #seniority__chipList>
          <mat-chip class="mr-2 my-1 rightsideclose text-truncate green-chip" [removable]="removable"
            *ngIf="seniority.includes('All')">

            <span class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
              <span class="mx-1">All</span>
            </span>
            <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>
          </mat-chip>
        </mat-chip-set> -->
        <mat-chip-grid  #seniority__chipList *ngIf="!seniority.includes('All')">
              <mat-chip-row class="mr-2 my-1 p-1 rightsideclose text-truncate green-chip"  [removable]="removable" *ngFor="let cs of seniority">

                <span class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
                  <span class="mx-1">{{cs | titlecase}}</span>
                </span>
                <span matChipRemove  class="mr-1">
                    <i class="far fa-times f-12 green-chip" (click)="removeChip(cs, 'seniority')" style="margin-left: 1px; margin-top: 0px;"></i>
                  </span>

              </mat-chip-row>
            </mat-chip-grid>
         <mat-chip-grid  #seniority__chipList *ngIf="seniority.includes('All')">
              <mat-chip-row class="mr-2 my-1 p-1 rightsideclose text-truncate green-chip"  [removable]="removable">

                <span class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
                  <span class="mx-1">All</span>

                </span>
                <span matChipRemove  class="mr-1">
                    <i class="far fa-times f-12 green-chip" (click)="removeChip('All', 'seniority')" style="margin-left: 1px; margin-top: 0px;"></i>
                  </span>

              </mat-chip-row>
            </mat-chip-grid>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 small-select" style="margin-top: 10px;">

        <div class="d-flex">
          <p class="sub-heading  mb-1 font-weight-500">Years of Experience</p>
          <div class="d-flex align-items-center mb-2">
            <select data-testid="auto-advance-search-select-5" name="experiencetype" (change)="filterByStatus($event, 'experiencetype')"
              [(ngModel)]="experiencetype" class="new-form no-shadow wc-select f-12">
              <!-- <option value="Past" selected>Past</option> -->
              <!-- <option value="Current Role">Current Role</option>
                          <option value="Total">Total</option>
                          <option value="Average">Average</option> -->
              <option value="Total" selected>Total</option>
              <option value="Average">Average</option>
            </select>
          </div>
        </div>




        <div class="d-flex align-items-center">
          <label class="f-12 text-black mr-2">From</label>
          <input data-testid="auto-advance-search-input-9" class="wc-form-control no-shadow inputheight mb-2 mr-2 w-25" type="number"
            [formControl]="yearsofexperienceFrom" placeholder="eg. 1, 2"
            (keyup)="typeAheadSearch($event, 'fromyearsofexperience')">
          <label class="f-12 text-black mr-2">To</label>
          <input data-testid="auto-advance-search-input-10" class="wc-form-control no-shadow inputheight mb-2 w-25" type="number"
            [formControl]="yearsofexperienceTo" placeholder="eg. 1, 2"
            (keyup)="typeAheadSearch($event, 'toyearsofexperience')">
          <br>

        </div>

        <!-- <p *ngIf="yearsofexperienceFrom.hasError('invalidYears') || yearsofexperienceTo.hasError('invalidYears')" class="f-12 text-danger" style="margin-left: 120px;"> Invalid Input</p> -->
        <p style="margin-left: 45px;"
          *ngIf="(yearsofexperienceTo.value == 0) || (yearsofexperienceTo.value != null && yearsofexperienceFrom.value != null) && (yearsofexperienceFrom.value > yearsofexperienceTo.value) && !(yearsofexperienceFrom.value < 0 || yearsofexperienceFrom.value > 40 || currentyearsofexperienceTo.value > 40 || yearsofexperienceTo.value < 0)"
          class="f-12 text-danger"> Invalid Input </p>
        <p style="margin-left: 45px;"
          *ngIf="yearsofexperienceFrom.value < 0 || yearsofexperienceFrom.value > 40 || yearsofexperienceTo.value > 40 || yearsofexperienceTo.value < 0"
          class="f-12 text-danger"> Enter a valid number in the range (0 – 40)</p>
      </div>


      <div class="col-md-6 small-select" style="margin-top: 10px;">

        <div class="d-flex">
          <p class="sub-heading mb-1 font-weight-500">Years In Current Company</p>
        </div>




        <div class="d-flex align-items-center">
          <label class="f-12 text-black mr-2">From</label>
          <input data-testid="auto-advance-search-input-11" class="wc-form-control no-shadow inputheight mb-2 mr-2 w-25" type="number"
            [formControl]="currentyearsofexperienceFrom" placeholder="eg. 1, 2"
            (keyup)="typeAheadSearch($event, 'currentfromyearsofexperience')">
          <label class="f-12 text-black mr-2">To</label>
          <input data-testid="auto-advance-search-input-12" class="wc-form-control no-shadow inputheight mb-2 w-25" type="number"
            [formControl]="currentyearsofexperienceTo" placeholder="eg. 1, 2"
            (keyup)="typeAheadSearch($event, 'currenttoyearsofexperience')">
          <br>

        </div>


        <!-- <p *ngIf="currentyearsofexperienceFrom.hasError('invalidYears') || currentyearsofexperienceTo.hasError('invalidYears')" class="f-12 text-danger" style="margin-left: 120px;"> Invalid Input</p> -->
        <p style="margin-left: 45px;"
          *ngIf="(currentyearsofexperienceTo.value == 0 ) || (currentyearsofexperienceFrom.value != null && currentyearsofexperienceTo.value != null) && (currentyearsofexperienceFrom.value > currentyearsofexperienceTo.value) && !(currentyearsofexperienceFrom.value < 0 || currentyearsofexperienceFrom.value > 40 || currentyearsofexperienceTo.value > 40 || currentyearsofexperienceTo.value < 0)"
          class="f-12 text-danger"> Invalid Input </p>
        <p style="margin-left: 45px;"
          *ngIf="(currentyearsofexperienceFrom.value < 0 || currentyearsofexperienceFrom.value > 40 || currentyearsofexperienceTo.value > 40 || currentyearsofexperienceTo.value < 0)"
          class="f-12 text-danger"> Enter a valid number in the range (0 – 40)</p>
      </div>
    </div>
    <div class="row">

      <div class="col-md-12">
        <p class="search-heading">
          Education Details
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <p class="mb-1 font-weight-500">Education</p>
        <!-- (click)="typeAheadSearch($event, 'education')"  -->
        <div class="position-relative">
          <input data-testid="auto-advance-search-input-13" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="eg. Education"
            [formControl]="educationInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (keyup)="onTypeAheadSearch($event, 'education')" (keyup.enter)="selectedItem($event, 'education')"
            [matAutocomplete]="education_auto" [matChipInputFor]="education_chipList"
            [matChipInputAddOnBlur]="addOnBlur" (blur)="removeTypeahead('education')">
          <div *ngIf="showEducationLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>

          <mat-autocomplete #education_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'education')">
            <mat-option *ngFor="let education of educationList"
              [value]="{key: education.value, doc_count: education.doc_count}">
              <span class="d-flex align-items-center">
                <span class="text-truncate">{{(education.value) | titlecase}}</span>
                <!-- <span class="f-12 text-9696"> ({{education.doc_count}})</span> -->
              </span>
            </mat-option>
          </mat-autocomplete>
          <mat-chip-grid #education_chipList>
            <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip f-12" [removable]="removable"
              (removed)="removeChip(education, 'education')" *ngFor="let education of educationSelectedList">

              <span class="trim-chip text-truncate text-webbtree-green">{{education.chipkey | titlecase}}
                <!-- <span class="f-12 text-webbtree-green">({{education.doc_count}})</span> -->
              </span>
              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="d-flex flex-column">
            <span class="trim-chip  text-webbtree-green underline-on-hover d-flex" *ngFor="let jt of educationTopList"
              (click)="addToSelectedList(jt,'jobtitle')">
              <span class="text-truncate">{{jt.key | titlecase}}</span>
              <span class="f-12 text-webbtree-green">({{jt.doc_count}})</span>
            </span>
          </div>
        </div>
      </div>




      <div class="col-md-6">
        <p class="mb-1 font-weight-500">Field Of Study</p>
        <!-- (click)="typeAheadSearch($event, 'fieldofstudy')" -->
        <div class="position-relative">
          <input data-testid="auto-advance-search-input-14" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="eg. Sociology, Engineering, etc"
            [formControl]="fieldOfStudyInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (keyup.enter)="selectedItem($event, 'fieldofstudy')" (keyup)="onTypeAheadSearch($event, 'fieldofstudy')"
            [matAutocomplete]="fieldofstudy_auto" [matChipInputFor]="fieldofstudy_chipList"
            [matChipInputAddOnBlur]="addOnBlur" (blur)="removeTypeahead('fieldofstudy')">
          <div *ngIf="showFieldOfStudyLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>

          <mat-autocomplete #fieldofstudy_auto="matAutocomplete"
            (optionSelected)="selectedItem($event, 'fieldofstudy')">
            <mat-option *ngFor="let fieldofstudy of fieldOfStudyList"
              [value]="{key: fieldofstudy.value, doc_count: fieldofstudy.doc_count}">
              <span class="d-flex align-items-center">
                <span class="text-truncate">{{fieldofstudy.value | titlecase}}</span>
                <!-- <span class="f-12 text-9696"> ({{fieldofstudy.doc_count}})</span> -->
              </span>
            </mat-option>
          </mat-autocomplete>
          <mat-chip-grid #fieldofstudy_chipList>
            <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip f-12" [removable]="removable"
              (removed)="removeChip(fieldofstudy, 'fieldofstudy')"
              *ngFor="let fieldofstudy of fieldOfStudySelectedList">

              <span class="trim-chip text-truncate text-webbtree-green">{{fieldofstudy.chipkey | titlecase}}
                <!-- <span class="f-12 text-webbtree-green">({{fieldofstudy.doc_count}})</span> -->
              </span>
              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="d-flex flex-column">
            <span class="trim-chip text-webbtree-green underline-on-hover d-flex" *ngFor="let jt of fieldOfStudyTopList"
              (click)="addToSelectedList(jt,'fieldofstudy')">
              <span class="text-truncate">{{jt.key | titlecase}}</span>
              <span class="f-12 text-webbtree-green">({{jt.doc_count}})</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">


      <div class="col-md-6 mt-3">
        <p class="mb-1 font-weight-500">Schools</p>
        <!-- (click)="typeAheadSearch($event, 'school')"  -->
        <div class="position-relative">
          <input data-testid="auto-advance-search-input-15" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="eg. School"
            [formControl]="schoolInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (keyup)="onTypeAheadSearch($event, 'school')" (keyup.enter)="selectedItem($event, 'school')"
            [matAutocomplete]="school_auto" [matChipInputFor]="school_chipList" [matChipInputAddOnBlur]="addOnBlur"
            (blur)="removeTypeahead('school')">
          <div *ngIf="showSchoolLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>

          <mat-autocomplete #school_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'school')">
            <mat-option *ngFor="let school of schoolList" [value]="{key: school.value, doc_count: school.doc_count}">
              <span class="d-flex align-items-center">
                <span class="text-truncate">{{(school.value) | titlecase}}</span>
                <!-- <span class="f-12 text-9696"> ({{school.doc_count}})</span> -->
              </span>
            </mat-option>
          </mat-autocomplete>
          <mat-chip-grid #school_chipList>
            <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip f-12" [removable]="removable"
              (removed)="removeChip(school, 'school')" *ngFor="let school of schoolSelectedList">

              <span class="trim-chip text-truncate text-webbtree-green">{{school.chipkey | titlecase}}
                <!-- <span class="f-12 text-webbtree-green">({{school.doc_count}})</span> -->
              </span>
              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="d-flex flex-column">
            <span class="trim-chip text-webbtree-green underline-on-hover d-flex" *ngFor="let jt of schoolTopList"
              (click)="addToSelectedList(jt,'school')">
              <span class="text-truncate">{{jt.key | titlecase}}</span>
              <span class="f-12 text-webbtree-green">({{jt.doc_count}})</span>
            </span>
          </div>
        </div>

      </div>



      <div class="col-md-6 mt-3">
        <p class="mb-1 font-weight-500">Education Location</p>
        <!-- (click)="typeAheadSearch($event, 'school')"  -->
        <div class="position-relative">
          <input data-testid="auto-advance-search-input-16" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="Enter Location"
            [formControl]="schoolLocationInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (keyup)="onTypeAheadSearch($event, 'schoollocation')" (keyup.enter)="selectedItem($event, 'schoollocation')"
            [matAutocomplete]="schoollocation_auto" [matChipInputFor]="schoollocation_chipList"
            [matChipInputAddOnBlur]="addOnBlur" (blur)="removeTypeahead('schoollocation')">
          <div *ngIf="showSchoolLocationLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>

          <mat-autocomplete #schoollocation_auto="matAutocomplete"
            (optionSelected)="selectedItem($event, 'schoollocation')">
            <mat-option *ngFor="let school of schoolLocationList"
              [value]="{key: school.value, doc_count: school.doc_count}">
              <span class="d-flex align-items-center">
                <span class="text-truncate">{{(school.value) | titlecase}}</span>
                <!-- <span class="f-12 text-9696"> ({{school.doc_count}})</span> -->
              </span>
            </mat-option>
          </mat-autocomplete>
          <mat-chip-grid #schoollocation_chipList>
            <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip f-12" [removable]="removable"
              (removed)="removeChip(school, 'schoollocation')" *ngFor="let school of schoolLocationSelectedList">

              <span class="trim-chip text-truncate text-webbtree-green">{{school.chipkey | titlecase}}
                <!-- <span class="f-12 text-webbtree-green">({{school.doc_count}})</span> -->
              </span>
              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="d-flex flex-column">
            <span class="trim-chip text-webbtree-green underline-on-hover d-flex"
              *ngFor="let jt of schoolLocationTopList" (click)="addToSelectedList(jt,'schoolinput')">
              <span class="text-truncate">{{jt.key | titlecase}}</span>
              <span class="f-12 text-webbtree-green">({{jt.doc_count}})</span>
            </span>
          </div>
        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-md-6 mt-3" style="margin-top: 10px;">
        <div class="d-flex">
          <p class="sub-heading mb-1 font-weight-500">Year of graduation</p>
        </div>

        <div class="d-flex align-items-center">
          <label class="f-12 text-black mr-2">From</label>
          <select data-testid="auto-advance-search-select-6" name="fromgraduationyear" placeholder="YYYY" [(ngModel)]="fromgraduationyearFilter"
            style="width: fit-content;" (change)="typeAheadSearch($event, 'fromgraduationyear')"
            class="wc-form-control position-relative no-outline inputheight wc-select">
            <option value="null" selected disabled>Select year</option>

            <span *ngFor="let year of graduationYearList('from')">
              <option [value]=year>{{year}}</option>
            </span>
          </select>

          <label class="f-12 text-black m-2">To</label>
          <select data-testid="auto-advance-search-select-7" name="torgaduationyear" placeholder="YYYY" [(ngModel)]="tograduationyearFilter"
            style="width: fit-content;" (change)="typeAheadSearch($event, 'tograduationyear')"
            class="wc-form-control position-relative no-outline inputheight wc-select">
            <option value="null" selected disabled>Select year</option>

            <span *ngFor="let year of graduationYearList('to')">
              <option [value]=year>{{year}}</option>
            </span>
          </select>
          <br>
        </div>
      </div>

    </div>


    <div class="row">
      <div class="col-md-12" style="margin-top: 10px;">
        <p class="search-heading">
          Additional Details
        </p>

        <!-- Name filter-->



        <!-- <div class="position-relative no-outline inputheight gender-section">
                        <label>
                            <input data-testid="auto-advance-search-input-17" type="radio" name="gender" (change)="selectedItem('Female', 'gender')" [(ngModel)]="gender" value="Female">
                            Female
                        </label>
                        <label>
                            <input data-testid="auto-advance-search-input-18" type="radio" name="gender" (change)="selectedItem('Male', 'gender')" [(ngModel)]="gender" value="Male">
                            Male
                        </label>
                        <label>
                            <input data-testid="auto-advance-search-input-19" type="radio" name="gender" (change)="selectedItem('Not Known', 'gender')" [(ngModel)]="gender" value="Not Known">
                            Not Known
                        </label>
                    </div> -->
      </div>

    </div>
    <div class="row">
      <div class="col-md-6 small-select">
        <div class="d-flex">
          <p class="sub-heading mb-1 font-weight-500">Name</p>
        </div>
        <div class="position-relative">
          <input data-testid="auto-advance-search-input-20" class="wc-form-control no-shadow w-100 inputheight mb-2" [formControl]="nameInput"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (keyup)="onTypeAheadSearch($event, 'fullname')"
            (keyup.enter)="selectedItem($event, 'fullname')" placeholder="eg. firstname, lastname"
            [matAutocomplete]="fullname_auto" [matChipInputFor]="fullname_chipList"
            (blur)="removeTypeahead('fullname')">
          <div *ngIf="showFunctionsLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <mat-autocomplete #fullname_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'fullname')">
          <mat-option *ngFor="let fn of fullnameList" [value]="{key: fn.value, doc_count: fn.doc_count}">
            <span class="d-flex align-items-center">
              <span class="text-truncate">{{fn.value | titlecase}}</span>
            </span>
          </mat-option>
        </mat-autocomplete>
        <mat-chip-set #fullname_chipList>
          <mat-chip class="mr-2 my-1 rightsideclose text-truncate green-chip" [removable]="removable"
            *ngFor="let name of fullNameSelectedList" (removed)="removeChip(name, 'fullname')">

            <span class="trim-chip text-truncate green-chip hoverable-element f-12 d-flex align-items-center">
              <span class="mx-1">{{name.chipkey | titlecase}}</span>
            </span>
            <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 0px;"></i>
              </span>

          </mat-chip>
        </mat-chip-set>
      </div>
      <div class="col-md-6">
        <p class="sub-heading mb-1 font-weight-500">Gender</p>

        <div class="position-relative no-outline d-flex">
          <label for="allRadio" class="customeRadioBtn">
            All
            <input data-testid="auto-advance-search-input-21" type="radio" name="gender" (change)="selectedItem('All', 'gender')" [(ngModel)]="gender" value="All"
              id="allRadio">
            <span class="checkmark"></span>
          </label>

          <label for="femaleRadio" class="customeRadioBtn">
            Women
            <input data-testid="auto-advance-search-input-22" type="radio" name="gender" (change)="selectedItem('Female', 'gender')" [(ngModel)]="gender"
              value="Female" id="femaleRadio">
            <span class="checkmark"></span>

          </label>


          <label for="maleRadio" class="customeRadioBtn">
            Men
            <input data-testid="auto-advance-search-input-23" type="radio" name="gender" (change)="selectedItem('Male', 'gender')" [(ngModel)]="gender"
              value="Male" id="maleRadio">
            <span class="checkmark"></span>

          </label>

          <!-- <label for="unknownRadio" class="customeRadioBtn">
                        Not Known

                        <input data-testid="auto-advance-search-input-24" type="radio" name="gender" (change)="selectedItem('Not Known', 'gender')" [(ngModel)]="gender" value="Not Known" id="unknownRadio">
                        <span class="checkmark"></span>

                      </label> -->
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="d-flex">
          <p class="sub-heading mb-1 font-weight-500">Highlight</p>
        </div>
        <div class="advsearchpinput  highlight-select">
          <p-multiSelect [options]="highLightOptions" optionLabel="label" optionValue="id"
            [(ngModel)]="highlightSelectedControl" (onChange)="onChangeHighlights($event)"
            placeholder="Select Highlight" [filter]="false">
            <ng-template let-value pTemplate="selectedItems">
              <!-- <div>Select Highlight</div> -->
              <!-- <span *ngIf="!value || value.length === 0">
                Select Company Size
              </span> -->
              <span *ngIf="value?.length">
                {{ value.length }} selected
              </span>
            </ng-template>
            <ng-template pTemplate="header">
              <div class="flex align-items-center gap-2" style="position: absolute!important; left: 36px!important;">
                <div class="p-multiselect-header-checkbox">
                  <span class="p-checkbox-label">All</span>
                </div>
              </div>
            </ng-template>
            <ng-template let-cs pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div class="highlight-pill" ngClass="highlight-pill-{{cs.color}}">
                  <span *ngIf="cs?.imageName" class="mr-1">
                    <img [src]="'assets/highlights/' + cs.imageName + '.svg'" alt="">
                  </span>
                  {{ cs.label }}
                </div>
              </div>
            </ng-template>
          </p-multiSelect>
          <div class="mt-2">
            <!-- <mat-chip-set #highlight_chipList *ngIf="highlightsSelectedList.length">
              <mat-chip class="mr-2 my-1 rightsideclose text-truncate" [removable]="removable"
                ngClass="highlight-pill-{{hl.color}}" *ngFor=" let hl of highlightsSelectedList">

                <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center">
                  <span class="mx-1">
                    <span *ngIf="hl?.imageName" class="mr-1">
                      <img [src]="'assets/highlights/' + hl.imageName + '.svg'" alt="">
                    </span>
                    {{hl.label}}
                  </span>
                </span>
                <span matChipRemove  class="mr-1">
                   <i class="far fa-times f-12 ml-2" style="margin-left: 1px;"
                  (click)="removeChip(hl, 'highlight')"></i>
                </span>
              </mat-chip>
            </mat-chip-set> -->
            <mat-chip-grid  #highlight_chipList *ngIf="highlightsSelectedList.length">
              <mat-chip-row class="mr-2 my-1 p-1 rightsideclose text-truncate green-chip"  [removable]="removable" ngClass="highlight-pill-{{hl.color}}" *ngFor=" let hl of highlightsSelectedList">

                <span class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
                  <span class="mx-1">
                    <span *ngIf="hl?.imageName" class="mr-1">
                      <img [src]="'assets/highlights/' + hl.imageName + '.svg'" alt="">
                    </span>
                    {{hl.label}}
                  </span>

                </span>
                <span matChipRemove  class="mr-1">
                    <i class="far fa-times f-12 green-chip" (click)="removeChip(hl, 'highlight')" style="margin-left: 1px; margin-top: 0px;"></i>
                  </span>

              </mat-chip-row>
            </mat-chip-grid>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="d-flex">
          <p class="sub-heading mb-1 font-weight-500">Webbtree True level</p>
        </div>
        <div class="position-relative advsearchpinput">

          <p-multiSelect [options]="positionHierarchyData" [(ngModel)]="positionhierarchy"
            (onChange)="selectedItem($event, 'positionhierarchy')" placeholder="Select Position Hierarchy"
            optionLabel="name" [filter]="false">
            <ng-template let-value pTemplate="selectedItems">
              <!-- <div>Select Webbtree True Level</div> -->
              <!-- <span *ngIf="!value || value.length === 0">
                Select Company Size
              </span> -->
              <span *ngIf="value?.length">
                {{ value.length }} selected
              </span>
            </ng-template>
            <ng-template pTemplate="header">
              <div class="flex align-items-center gap-2" style="position: absolute!important; left: 36px!important;">
                <div class="p-multiselect-header-checkbox">
                  <span class="p-checkbox-label">All</span>
                </div>
              </div>
            </ng-template>
            <ng-template let-ph pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ ph | titlecase }}</div>
              </div>
            </ng-template>
          </p-multiSelect>
          <div class="mt-2">
            <!-- <mat-chip-set class="mb-2 mt-2" #positionhierarchy__chipList *ngIf="!positionhierarchy.includes('All')">
              <mat-chip class="mr-2 mb-1 rightsideclose text-truncate d-flex" [removable]="removable"
                style="background-color: #e4f1f3;" *ngFor="let ph of positionhierarchy">
                <span class="trim-chip text-truncate f-12 font-weight-lighter">
                  <span class="mx-1" [matTooltip]="ph | titlecase" [matTooltipClass]="{ 'ai-tooltip text-black': true }"
                    matTooltipPosition="above">{{ph | titlecase}}</span>
                </span>
                <span matChipRemove  class="mr-1">
                  <i class="far fa-times f-12 font-weight-lighter ml-1" style="margin-left: 1px;
                    margin-top: 5px;" (click)="removeChip(ph, 'positionhierarchy')"></i>
                </span>
              </mat-chip>
            </mat-chip-set>

            <mat-chip-set class="mb-2 mt-2" #positionhierarchy__chipList>
              <mat-chip class="mr-2 mb-1 mt-2 rightsideclose text-truncate d-flex" [removable]="removable"
                style="background-color: #e4f1f3;" *ngIf="positionhierarchy.includes('All')">
                <span matChipRemove  class="mr-1">
                  <i class="far fa-times f-12 font-weight-lighter" style="margin-left: 1px;
                    margin-top: 5px;" (click)="removeChip('All', 'positionhierarchy')"></i>
                </span>
                <span class="trim-chip text-truncate f-12 font-weight-lighter">
                  <span class="mx-1">All</span>
                </span>
              </mat-chip>
            </mat-chip-set> -->
            <mat-chip-grid  #positionhierarchy__chipList *ngIf="!positionhierarchy.includes('All')">
              <mat-chip-row class="mr-2 my-1 p-1 rightsideclose text-truncate green-chip" [removable]="removable" *ngFor="let ph of positionhierarchy">

                <span class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
                  <span class="mx-1" [matTooltip]="ph | titlecase" [matTooltipClass]="{ 'ai-tooltip text-black': true }"
                        matTooltipPosition="above">{{ph | titlecase}}</span>

                </span>
                <span matChipRemove  class="mr-1">
                    <i class="far fa-times f-12 green-chip" (click)="removeChip(ph, 'positionhierarchy')"  style="margin-left: 1px; margin-top: 0px;"></i>
                  </span>

              </mat-chip-row>
            </mat-chip-grid>
            <mat-chip-grid  #positionhierarchy__chipList *ngIf="positionhierarchy.includes('All')">
              <mat-chip-row class="mr-2 my-1 p-1 rightsideclose text-truncate green-chip" [removable]="removable" *ngFor="let ph of positionhierarchy">

                <span class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
                 <span class="mx-1">All</span>

                </span>
                <span matChipRemove  class="mr-1">
                    <i class="far fa-times f-12 green-chip" (click)="removeChip('All', 'positionhierarchy')" style="margin-left: 1px; margin-top: 0px;"></i>
                  </span>

              </mat-chip-row>
            </mat-chip-grid>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
